import React, { FC } from 'react';
import { withStyles, WithStyles } from '@material-ui/core/styles';

import styles from './styles';

interface IProps extends WithStyles<typeof styles> {
  height?: number;
  maxWidth?: number;
  index?: number;
}

const Content: FC<IProps> = ({ classes, index, height, maxWidth }) => {
  const firstWidth = maxWidth * 0.7;
  const secondWidth = maxWidth * 0.9;
  const thirdWidth = maxWidth;

  const style = {
    height,
    width: getContentWidth(),
    borderRadius: 4,
  };

  function getContentWidth() {
    const firstInSeries = index % 3 === 0;
    const secondInSeries = index % 3 === 1;
    const thirdInSeries = index % 3 === 2;

    if (firstInSeries) {
      return firstWidth;
    }

    if (secondInSeries) {
      return secondWidth;
    }

    if (thirdInSeries) {
      return thirdWidth;
    }

    return secondWidth;
  }

  return <div style={style} className={classes.animation} />;
};

Content.defaultProps = {
  height: 12,
  maxWidth: 300,
  index: null,
};

export default withStyles(styles)(Content);
